import * as Sentry from '@sentry/nextjs'
import { AxiosError } from 'axios'

// `_app` registers the axios interceptors on every render, so one failed
// request reaches the reporter once per registered interceptor. Remember what
// was already sent to report each failure once.
const reported = new WeakSet<AxiosError>()

/**
 * Reports a request that died without an HTTP response (the user sees
 * "could not reach the server"). Nothing about it exists server-side, so this
 * is the only trace - e.g. of the MFA-setup "Network Error".
 */
export const reportNetworkError = (error: AxiosError) => {
  if (reported.has(error)) {
    return
  }

  reported.add(error)

  Sentry.captureException(error, {
    tags: { kind: 'network-error' },
    extra: {
      method: error.config?.method,
      url: error.config?.url,
      baseURL: error.config?.baseURL,
      code: error.code,
      online: typeof navigator === 'undefined' ? undefined : navigator.onLine,
    },
  })
}
